var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglishFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "72 0 216 216",
    enableBackground: "new 72 0 216 216",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    fill: "#231F20",
    enableBackground: "new    ",
    d: "M234,63.6H123.4h-7.8v7.8v42v7.8V145v7.8h7.8H234h7.8V145V71.4 v-7.8C241.8,63.6,234,63.6,234,63.6z M234,145H123.4v-23.7v-7.8v-42H234V145z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "123.3,70.3 234.3,70.3 234.3,145.2 123.3,145.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.6,
    enableBackground: "new    ",
    points: "234.3,100.3 184.3,100.3 184.3,70.3 173.2,70.3 173.2,100.3  123.3,100.3 123.3,115.2 173.2,115.2 173.2,145.2 184.3,145.2 184.3,115.2 234.3,115.2  "
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    enableBackground: "new    ",
    d: "M197.3,120.2h8.3l28.7,19.4v5.6 M160.3,95.3H152l-28.7-19.4v-5.6L160.3,95.3 L160.3,95.3z M160.3,120.2h8.3l-37,25h-8.3L160.3,120.2L160.3,120.2z M197.3,95.3H189l37-25h8.3L197.3,95.3L197.3,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    enableBackground: "new    ",
    d: "M123.3,120.2v16.6l24.6-16.6 M234.3,120.2v16.6l-24.6-16.6L234.3,120.2 L234.3,120.2z M123.3,95.3V78.7l24.6,16.6L123.3,95.3L123.3,95.3z M234.3,95.3V78.7l-24.6,16.6L234.3,95.3L234.3,95.3z  M169.5,145.2v-22.9l-33.8,22.9H169.5L169.5,145.2z M188,145.2v-22.9l33.8,22.9H188L188,145.2z M169.5,70.3v22.9l-33.8-22.9H169.5 L169.5,70.3z M188,70.3v22.9l33.8-22.9H188L188,70.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english-flag.36d606515df4c720e7e47a8069708eae.svg";
export { ForwardRef as ReactComponent };